import { render, staticRenderFns } from "./initialSetting.vue?vue&type=template&id=6db740ad&scoped=true"
import script from "./initialSetting.vue?vue&type=script&lang=js"
export * from "./initialSetting.vue?vue&type=script&lang=js"
import style0 from "./initialSetting.vue?vue&type=style&index=0&id=6db740ad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db740ad",
  null
  
)

export default component.exports